



























import { Component, Mixins, Prop } from 'vue-property-decorator';
import { CatalogSession } from '@/Model/sessions/catalogTypes';

import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import SessionPriceTag from '@/components/familyPortal/sessionCard/SessionPriceTag.vue';
import BaseCard from '@/components/familyPortal/sessionCard/BaseCard.vue';

@Component({
  components: {
    SessionPriceTag,
    BaseCard,
  }
})
export default class ApplicationCard extends Mixins(DeviceWidthCheckerMixin) {
  @Prop({ type: Object, required: true }) readonly session!: CatalogSession;
}
